import { styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import RadioBase from './RadioBase.js';

const RadioLabelCircle = styled(Div)`
  position: relative;
  border-radius: 50%;
  margin-right: ${({
  theme
}) => `calc(${theme.spacing.xs}px)`};
  transition: border-color 0.15s;
  width: var(--size);
  height: var(--size);
  --size: 16px;
  --innerSize: 8px;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    border-radius: 50%;
    background-color: transparent;
  }

  ${({
  isChecked,
  isDisabled,
  theme
}) => {
  if (isChecked) {
    return css`
        background-color: ${theme.palette.primary.main};

        &::after {
          content: '';
          position: absolute;
          background-color: ${isDisabled ? theme.palette.action.disabled : theme.palette.common.white};
          border-radius: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: var(--innerSize);
          height: var(--innerSize);
        }
      `;
  }
  return ``;
}};

  ${({
  isDisabled,
  theme
}) => {
  if (isDisabled) {
    return css`
        color: ${theme.palette.text.disabled};
        background-color: ${theme.palette.action.disabledBackground};
        border: 1px solid ${theme.palette.action.disabledBackground};
      `;
  }
  return css`
      border: 1px solid ${theme.palette.primary.main};
    `;
}};
`;

const Radio = props => {
  return /*#__PURE__*/createElement(RadioBase, props, /*#__PURE__*/createElement(RadioLabelCircle, {
    isChecked: props.isChecked,
    isDisabled: props.isDisabled
  }), /*#__PURE__*/createElement("span", null, props.label));
};

export default Radio;
